module.exports = __webpack_public_path__ + "static/media/ClearIcon.734b2b44.svg";